module.exports = __webpack_public_path__ + "img/list03.f212ab0b.jpg";